import { css } from "@emotion/react";

export interface NewStylesProps {
  newStyles?: boolean;
}

export const NewInputStyles = css`
  font-family: Ginto, sans-serif;
  font-weight: 500;
`;
